import util from '@/libs/util'

export default {
  namespaced: true,
  state: {
    // 财务信息
    account: {}
  },
  actions: {
    /**
     * @description 设置财务数据
     * @param {Object} context
     * @param {*} account account
     */
    setCurrentFinance({ state, dispatch }, account) {
      return new Promise(async resolve => {
        // store 赋值
        state.account = account
        // 存cookie
        util.cookies.set('ACCOUNT_SET_ID', account.accountId)
        util.cookies.set('TERM_ID', account.termId)
        util.cookies.set('TERM', account.term)
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'finance',
          path: 'finance.account',
          value: account,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取财务数据
     * @param {Object} context
     */
    async loadCurrentFinance({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.account = await dispatch('d2admin/db/get', {
          dbName: 'finance',
          path: 'finance.account',
          defaultValue: {},
          user: true
        }, { root: true })
        // 存cookie
        if (state.account) {
          util.cookies.set('ACCOUNT_SET_ID', state.account.accountId)
          util.cookies.set('TERM_ID', state.account.termId)

          let term=util.cookies.get('TERM')
          if(term){
              state.account.term=JSON.parse(term)
          }
        }
        // end
        resolve()
      })
    }
  }
}
